/*
  Jenniferloyo.sport — site-wide scroll reveal.
  Reveals every storefront section (except the first and main template sections,
  which hold product forms, cart and search) plus product/collection cards.
  Content stays visible if this never runs: hidden state needs html.jl-site-motion.
*/
(() => {
  if (window.JlSiteReveal) return;

  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window) || root.dataset.jlReveal === 'off') return;

  root.classList.add('jl-site-motion');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('jl-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  const CARD_SELECTOR = '.product-card, .resource-card, .collection-card, .blog-post-card, .article-card';

  const tag = (element, delay) => {
    if (element.hasAttribute('data-jl-site-reveal') || element.closest('[data-jl-reveal]')) return;
    element.setAttribute('data-jl-site-reveal', '');
    element.style.setProperty('--jl-site-delay', String(delay));
    observer.observe(element);
  };

  const scan = (scope = document) => {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    main.querySelectorAll(':scope > .shopify-section').forEach((section, index) => {
      if (index === 0 || section.id.includes('__main')) return;
      // Brand sections already reveal their own children.
      if (section.querySelector('.jl-section')) return;
      tag(section, 0);
    });

    scope.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const siblings = card.parentElement ? Array.from(card.parentElement.children) : [card];
      tag(card, Math.min(siblings.indexOf(card), 6));
    });
  };

  window.JlSiteReveal = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Product grids that load more items (filters, pagination, recommendations).
  const mutation = new MutationObserver((records) => {
    for (const record of records) {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    }
  });
  mutation.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    event.target.classList.add('jl-in');
    event.target.querySelectorAll('[data-jl-site-reveal]').forEach((element) => element.classList.add('jl-in'));
  });
})();
